import { useQuery } from 'react-query';
import { DOC_TYPE_AADE_CODE_VALUES } from '../../../interfaces/documentType.interface';
import { SORT_BY_SALES, SORT_DIRECTION } from '../../../interfaces/enumerables';
import { InvoiceInList } from '../../../interfaces/invoice.interface';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

const getSalesForDelivery = async (params: {
  page: number;
  orderBy: string;
  order: string;
}): Promise<GetEntities<InvoiceInList>> => {
  await queryClient?.cancelQueries({ queryKey: ['useSalesForDelivery'] });

  const resp = await apiRQ.get<GetEntities<InvoiceInList>>('/invoices/delivery', { params });

  return resp.data;
};

export const useSalesForDelivery = (
  page: number,
  sortBy = SORT_BY_SALES.SERIAL_NUMBER,
  order = SORT_DIRECTION.ASC,
  search?: string,
  type?: DOC_TYPE_AADE_CODE_VALUES | null,
) => {
  return useQuery<GetEntities<InvoiceInList>, Error>(
    ['useSalesForDelivery', page, sortBy, order, search, type],
    () => getSalesForDelivery({ page, orderBy: sortBy, order }),
    {
      cacheTime: 200,
      staleTime: 200,
      retry: 3,
    },
  );
};
